/**
 * All the Functionalities Related to Reports
 * Module is included here
 */
import { ReviewReportsPageModule } from "./reviewReports/review-reports-page.module";
import { RequisitionPerformanceReportPageModule } from "./requisitionPerformanceReport/requisition-performance-report-page.module";
import * as Reports from "raw-loader!src/app/public/app/partials/missioncontrol/reports/reports.html";
var reportsmanagementmodule = angular.module('4dot5.missioncontrolmodule.reportsmodule', ['4dot5.missioncontrolmodule.reportsmodule.sourcingperformancemodule',
    '4dot5.missioncontrolmodule.reportsmodule.requisitionperformancemodule',
    '4dot5.missioncontrolmodule.reportsmodule.teammemberperformancemodule',
    ReviewReportsPageModule,
    RequisitionPerformanceReportPageModule
]);
reportsmanagementmodule.constant('REPORTSCONSTANTS', {
    CONFIG: {
        STATE: 'missioncontrol.reports',
        URL: '/reports',
        CONTROLLER: 'ReportsController',
        TEMPLATE: Reports.default,
    }
});
reportsmanagementmodule.config(['$stateProvider',
    'REPORTSCONSTANTS',
    function ($stateProvider, REPORTSCONSTANTS) {
        $stateProvider.state(REPORTSCONSTANTS.CONFIG.STATE, {
            url: REPORTSCONSTANTS.CONFIG.URL,
            templateUrl: REPORTSCONSTANTS.CONFIG.TEMPLATEURL,
            controller: REPORTSCONSTANTS.CONFIG.CONTROLLER,
            data: {
                requireLogin: true
            },
            params: {
                reportType: null
            }
        });
    }
]);
reportsmanagementmodule.controller('ReportsController', ['$scope',
    '$state',
    '$window',
    '$location',
    '$stateParams',
    '$rootScope',
    '$http',
    'StorageService',
    'genericService',
    'REPORTSCONSTANTS',
    function ($scope, $state, $window, $location, $stateParams, $rootScope, $http, StorageService, genericService, REPORTSCONSTANTS) {
        console.log('ReportsManagementController');
    }
]);
//# sourceMappingURL=reports.js.map